<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="$props.readonly && model"
    class="max-w-full whitespace-pre-line pb-4"
    v-html="computedHtml"
    />
  <BlogContentEditWrapper v-else-if="model" v-model="model">
    <ui-text
      v-model="computedContent"
      label="Content"
      rows="4"
      />
  </BlogContentEditWrapper>
</template>

<script setup lang="ts">
defineEmits(['remove'])
defineProps<{ readonly?: boolean }>()

const { locale } = useI18n()
const model = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')

const editingLang = computed(() => model.value ? (model.value.editing_language ?? locale.value) : locale.value)

const computedContent = computed({
  get: () => {
    if (!model.value) return ''
    const lang = editingLang.value
    if (lang !== 'en') {
      return model.value.meta?.i18n?.[lang as SupportedLanguages]?.content ?? model.value.content
    }
    return model.value.content
  },
  set: (value) => {
    if (!model.value) return
    const lang = editingLang.value
    if (lang !== 'en') {
      model.value.meta.i18n[lang as SupportedLanguages].content = value
    } else {
      model.value.content = value
    }
  },
})

const linkedWords = computed(() => modelBlog.value?.meta?.linked_words ?? {})

const regex = computed(() => {
  const words = Object.keys(linkedWords.value).filter(w => linkedWords.value[w])
  if (words.length === 0) return null
  return new RegExp(`\\b(${words.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})\\b`, 'g')
})

const computedHtml = computed(() => {
  if (!model.value) return ''
  let htmlString = computedContent.value || model.value.content

  if (regex.value) {
    htmlString = htmlString.replace(regex.value, (matched) => {
      const url = linkedWords.value[matched]
      return `<a class="ui-link decent blue" data-linkedstring="${matched}" href="${url}" target="_blank">${matched}</a>`
    })
  }
  return htmlString
})

watchEffect(() => {
  // wait for DOM update
  nextTick(() => {
    const links = document?.querySelectorAll('a[data-linkedstring]') ?? []
    const seen = new Set<string>()
    links.forEach(link => {
      const linkedString = link.getAttribute('data-linkedstring')
      if (linkedString && seen.has(linkedString)) {
        link.classList.remove('blue')
      } else if (linkedString) {
        seen.add(linkedString)
      }
    })

    const emptyLinks = document?.querySelectorAll('a[data-linkedstring]:not([href])') ?? []
    emptyLinks.forEach(link => link.remove())
  })
})
</script>
